var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7124 8.59151L17.4133 0.802246H15.8254L10.0071 7.56555L5.35992 0.802246H0L7.02738 11.0296L0 19.1978H1.58799L7.73237 12.0555L12.6401 19.1978H18L10.7121 8.59151H10.7124ZM8.53747 11.1197L7.82546 10.1013L2.16017 1.99766H4.59922L9.17118 8.53752L9.8832 9.55593L15.8262 18.0567H13.3871L8.53747 11.1201V11.1197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcom);
export default __webpack_public_path__ + "static/media/xcom.159846311fe7efa47b0b04042659c0c7.svg";
export { ForwardRef as ReactComponent };